interface AvatarProps {
  photoPath: string | null;
  handle: string;
  size?: number;
}

export function Avatar({ photoPath, handle, size = 40 }: AvatarProps) {
  if (photoPath) {
    return (
      <img
        src={photoPath}
        alt={`@${handle}`}
        width={size}
        height={size}
        className="rounded-full object-cover"
        loading="lazy"
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      className="rounded-full bg-primary flex items-center justify-center font-display text-accent"
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {handle[0]?.toUpperCase() ?? "?"}
    </div>
  );
}
